module.exports = __webpack_public_path__ + "img/note.03de46b8.svg";